var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "th",
    _vm._b(
      {
        staticClass: "sortable-head",
        on: {
          click: function ($event) {
            return _vm.$emit("sort", _vm.sortKey)
          },
        },
      },
      "th",
      _vm.$attrs,
      false
    ),
    [
      _c("div", { staticClass: "sortable-head-inner" }, [
        _c("span", [_vm._t("default")], 2),
        _vm._v(" "),
        _c("span", { staticClass: "sortable-icons" }, [
          _vm.isActive && _vm.dir === "asc"
            ? _c("i", { staticClass: "bi bi-arrow-up sort-icon active" })
            : _c("i", {
                staticClass: "bi bi-arrow-down sort-icon",
                class: { active: _vm.isActive && _vm.dir === "desc" },
              }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }